(function () {
    angular.module("Waiteraid")
        .run(function ($rootScope, $state, $window, $http) {
            $rootScope.$state = $state;
            $rootScope.currentState = '';
            //console.log(moment('2015-12-24'));

            $rootScope.getTemplateUrl = function (t) {
                return '/booking/index/getTemplate/' + t;
            };
            var viewAjax = false;
            $rootScope.$on('$locationChangeStart', function (evt, toState, toParams, fromState, fromParams) {
                viewAjax = true;
                $rootScope.currentState = toState;
            });
            $rootScope.$on('$viewContentLoaded', function () {
                window.setTimeout(function () {
                    const ps = document.querySelectorAll('.showHideTextWrap');
                    ps.forEach(function (elm) {
                        if (elm.scrollHeight > elm.clientHeight)
                            elm.classList.add('truncated');
                        else
                            elm.classList.remove('truncated');
                    });
                }, 200);
                //window.setTimeout(checkFooterPos,0);
                viewAjax = false;
                var state = $state.current;
                $window.scrollTo(0, 0);
                //console.log($state.current.name);
                if ($state.current.name !== 'time')
                    window.setTimeout(sendHeightEvent, 300);
                //window.setTimeout(checkFooterPos,0);
            });
        });
})();

